import { HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CostsPriceImportResult } from '../../catalog.model';
import { DateTime } from 'luxon';
import { AppServerAPI } from '@sdbn/common';

export class CostsPriceImportData {
  file: File;
  validFrom: Date;
  validUntil:Date;
}

@Component({
  selector: 'app-import-costsprice-dialog',
  templateUrl: './import-costsprice-dialog.component.html',
  styleUrls: ['./import-costsprice-dialog.component.scss']
})
export class importCostsPricesDialogComponent implements OnInit {

  @ViewChild('fileChooser') fileChooser: ElementRef;

  formGroup = new FormGroup({});

  confirmDisabled = true;

  costsPriceImportData = new CostsPriceImportData();

  importRunning = false;
  hasImportErrors = false;
  articlesWithNotModifiableCostsPrices = new Array<string>();

  constructor(
    public dialogRef: MatDialogRef<importCostsPricesDialogComponent>,
    private appServerAPI: AppServerAPI,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formGroup.addControl('date_from', new FormControl(null, [Validators.required]));
    this.formGroup.addControl('date_until', new FormControl(null, []));

  }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(formValues => {
      console.log('valueChanges', formValues);
      this.costsPriceImportData.validFrom = formValues.date_from;
      this.costsPriceImportData.validUntil = formValues.date_until;
    });

    this.formGroup.statusChanges.subscribe(status => {
      console.log('statusChanges', status)
      this.calculateConfirmButtonState();
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        this.confirmDisabled = true;
        this.uploadCostsPriceImportFile(reader.result);
      } catch (e) {
        console.log('load file failed:', e);
        this.confirmDisabled = false;
      }
    };
    reader.readAsArrayBuffer(this.costsPriceImportData.file);

  }

  chooseFile() {
    this.fileChooser.nativeElement.click();
  }

  onFileSelected(event: Event) {
    console.log('onFileSelected', event);
    const file: File = (event.target as HTMLInputElement).files[0];
    this.costsPriceImportData.file = file;
    this.calculateConfirmButtonState();
  }

  private calculateConfirmButtonState() {
    this.confirmDisabled = !this.formGroup.valid || this.costsPriceImportData?.file == null;
  }



  private uploadCostsPriceImportFile(content: any) {
    const url = `/client/erp-article/article/importCostsPrices`;
    let validFrom = DateTime.fromJSDate(this.costsPriceImportData.validFrom).toFormat('yyyyMMdd');
    let validUntil = this.costsPriceImportData.validUntil ? DateTime.fromJSDate(this.costsPriceImportData.validUntil).toFormat('yyyyMMdd') : null;
    let headers = new HttpHeaders({'Content-Type': this.costsPriceImportData.file.type, 'erp-import': JSON.stringify({validFrom: validFrom, validUntil: validUntil})});
    this.importRunning = true;
    return this.appServerAPI.postWithFileContent<CostsPriceImportResult>(url, content, headers).toPromise().then(response => {
      console.log('saveDocument call succeeded:', response);
      if (response.articlesWithNotModifiableCostsPrices != null && response.articlesWithNotModifiableCostsPrices.length > 0) {
        this.hasImportErrors = true;
        this.articlesWithNotModifiableCostsPrices = response.articlesWithNotModifiableCostsPrices;
        this.confirmDisabled = false;
      } else {
        this.hasImportErrors = false;
        this.dialogRef.close(this.costsPriceImportData);
      }
      this.importRunning = false;
    }, error => {
      console.log('saveDocument call failed:', error);
      this.confirmDisabled = false;
      this.importRunning = false;
    });
  }

}
